const ActionTypes = {
    SET_DIALOG_DATA: 'SET_DIALOG_DATA'
};

/**
 * Set data action.
 *
 * @param {Object} data - Dialog data.
 * @returns {Object} Action type and the new status.
 */
function setData (data = null) {

    return {
        type: ActionTypes.SET_DIALOG_DATA,
        data
    };
}

export {
    ActionTypes,
    setData
};


// WEBPACK FOOTER //
// ./src/js/store/actions/modals/dialog.js